import api from '../resources/axios';
import { Contract } from '../resources/types/contractsTypes';

export interface LastTripInfo {
  id: string;
  scooterName: string;
  createdAt: string;
  closedDate: string | undefined;
  active: boolean;
  periodSeconds: number;
  mileageMeters: number;
  sum: string | number;
  batteryStart?: number;
  batteryEnd?: number;
  cityName?: string;
  paymentType?: string;
  rawContract?: any;
}

export async function fetchLastTrip(userId: string): Promise<LastTripInfo | null> {
  try {
    const response = await api.get('/contracts/active', {
      params: { userId, active: false, limit: 1, page: 1 },
    });
    const contracts: Contract[] = response.data?.contracts || [];
    if (!contracts.length) return null;

    const c = contracts[0];
    return {
      id: c._id,
      scooterName: c.scooter?.name || '—',
      createdAt: c.createdAt,
      closedDate: c.closedDate,
      active: c.active,
      periodSeconds: c.period || 0,
      mileageMeters: c.mileage || 0,
      sum: c.sum,
      batteryStart: c.historyDetails?.batteryStart,
      batteryEnd: c.historyDetails?.batteryEnd,
      cityName: c.city?.name,
      paymentType: c.paymentType,
      rawContract: c,
    };
  } catch {
    return null;
  }
}

export function formatTripDuration(seconds: number): string {
  if (!seconds) return '—';
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) return `${h}год ${m}хв`;
  if (m > 0) return `${m}хв ${s}с`;
  return `${s}с`;
}

export function formatMileage(meters: number): string {
  if (!meters) return '—';
  if (meters >= 1000) return `${(meters / 1000).toFixed(2)} км`;
  return `${meters} м`;
}

export function tripToAiContext(trip: LastTripInfo): string {
  const lines = [
    `## Остання поїздка клієнта`,
    `- Самокат: ${trip.scooterName}`,
    `- Дата початку: ${new Date(trip.createdAt).toLocaleString('uk-UA')}`,
    trip.closedDate
      ? `- Дата завершення: ${new Date(trip.closedDate).toLocaleString('uk-UA')}`
      : `- Статус: активна/не завершена`,
    `- Тривалість: ${formatTripDuration(trip.periodSeconds)}`,
    `- Відстань: ${formatMileage(trip.mileageMeters)}`,
    `- Вартість: ${trip.sum}`,
  ];
  if (trip.batteryStart !== undefined && trip.batteryEnd !== undefined) {
    lines.push(`- Батарея: ${trip.batteryStart}% → ${trip.batteryEnd}%`);
  }
  if (trip.cityName) lines.push(`- Місто: ${trip.cityName}`);
  if (trip.paymentType) lines.push(`- Тип оплати: ${trip.paymentType}`);
  return lines.join('\n');
}
